module.exports = __webpack_public_path__ + "img/ys-9.6abf6b21.png";